import * as actions from "../../actions";
import {getApiConfig, getMasterFabricatorId} from "../../utilities";
import {getFeaturesChangesToPost} from "../FeaturesSetup/featuresAsyncActions";

const ActionTypes = {
  loadFeaturesStart: 'feature-creator-new/load-features-start',
  loadFeaturesEnd: 'feature-creator-new/load-features-end',
  resetFeatures: 'feature-creator-new/reset-features',
  setSearchTerm: 'feature-creator-new/set-search-term',
  setMode: 'feature-creator-new/set-mode',
  updateFeatureData: 'feature-creator-new/update-feature-data',
  cancelPendingChanges: 'feature-creator-new/cancel-pending-changes',
  saveFeaturesStart: 'feature-creator-new/save-features-start',
  saveFeaturesEnd: 'feature-creator-new/save-features-end',
  enableAll: 'feature-creator-new/enable-all',
  lockAll: 'feature-creator-new/lock-all',
  applyNewProperty: 'feature-creator-new/applyNewProperty',
  toggleApplyToFeatures: 'feature-creator-new/toggle-apply-to-features'
}

export default {
  loadFeatures(groupName, catId, withLoader = true) {
    return (dispatch, getState) => {
      dispatch({type: ActionTypes.loadFeaturesStart, payload: {groupName}});
      if (withLoader) {
        dispatch(actions.loadingDialog_show(true, 'Loading...', 'Loading features, this will take just a moment.'));
      }
      const state = getState();
      const {auth, asCustomer, featuresCreatorNew: {term, activeMode}, newScope} = state;
      const fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
      const {masterFabricatorId} = auth;

      let query = '';
      if (term) {
        query += "searchFilter=" + term;
      }
      if (activeMode !== 'All') {
        query += (term ? "&" : "") + "productType=" + (activeMode === 'Kitchen' ? 'KitchenVisualizer' : 'BathroomVisualizer');
      }
      if (query) {
        query = '?' + query;
      }
      const requestCount = state.featuresCreatorNew.featuresRequestCount;

      var tool = newScope.categoriesVisualizer;
      let masterFabId = getMasterFabricatorId(asCustomer.data ? asCustomer.data.masterFabricatorIds : auth.masterFabricatorIds, tool);
      return getApiConfig('ProjectScope').get(`/feature-group-features/${fabricatorId}/${masterFabId}/${catId}/${groupName}${query}`)
        .then(data => {
          console.log("loadFeatures response data", data);
          const state = getState();
          const {auth} = state;
          if (requestCount === state.featuresCreatorNew.featuresRequestCount) { // set only the latest request
            if (withLoader) {
              dispatch(actions.loadingDialog_show(false))
            }
            dispatch({
              type: ActionTypes.loadFeaturesEnd,
              payload: {...data, ...auth}
            })
          }
        })
        .catch((error) => {
          if (withLoader) {
            dispatch(actions.loadingDialog_show(false))
          }
          dispatch({type: ActionTypes.loadFeaturesEnd})
          console.error("feature-group-features error", error);
        });
    }
  },

  loadOnlyEnabledFeatures(groupName = "", fabricatorId = null, withLoader = true) {
    return (dispatch, getState) => {
      dispatch({type: ActionTypes.loadFeaturesStart, payload: {groupName}});
      if (withLoader) {
        dispatch(actions.loadingDialog_show(true, 'Loading...', 'Loading features, this will take just a moment.'));
      }
      const {auth, asCustomer} = getState();
      if (!fabricatorId) {
        fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
      }
      return getApiConfig('wizard/features/')
        .get(fabricatorId + "/" + groupName)
        .then((response) => {
          console.log("features response " + groupName + ":", response);
          dispatch({
            type: ActionTypes.loadFeaturesEnd,
            payload: {enabledFeatures: response, ...auth}
          });
          if (withLoader) {
            dispatch(actions.loadingDialog_show(false));
          }
        })
        .catch((response) => {
          console.log('error wizard-setup ->', response);
          if (withLoader) {
            dispatch(actions.loadingDialog_show(false));
          }
        });
    }
  },

  setSearchTerm(term) {
    return {
      type: this.ActionTypes.setSearchTerm,
      payload: {term}
    }
  },

  setMode(mode) {
    return {
      type: this.ActionTypes.setMode,
      payload: {mode}
    }
  },

  enableAll(enable, property) {
    return (dispatch, getState) => {
      const store = getState();
      dispatch({
        type: this.ActionTypes.enableAll,
        payload: {enable, property, selectedFilters: store.featuresFiltersState.selectedFilters, auth: store.auth}
      });
    }
  },

  lockAll(lock) {
    return (dispatch, getState) => {
      const store = getState();
      dispatch({
        type: this.ActionTypes.lockAll,
        payload: {lock, selectedFilters: store.featuresFiltersState.selectedFilters}
      });
    }
  },

  applyNewProperty(propertyName, propertyValue) {
    return (dispatch, getState) => {
      const store = getState();
      dispatch({
        type: this.ActionTypes.applyNewProperty,
        payload: {propertyName, propertyValue, selectedFilters: store.featuresFiltersState.selectedFilters}
      });
    }
  },

  toggleApplyToFeatures() {
    return { type: this.ActionTypes.toggleApplyToFeatures }
  },

  updateFeatureData({id, propName, propValue, isFromEnabled}) {
    return {
      type: this.ActionTypes.updateFeatureData,
      payload: {id, propName, propValue, isFromEnabled}
    }
  },

  cancelPendingChanges(catId) {
    return (dispatch, getState) => {
      dispatch({type: this.ActionTypes.cancelPendingChanges});

      const {featuresCreatorNew} = getState();
      this.loadFeatures(featuresCreatorNew.activeFeaturesGroupName, catId)(dispatch, getState);
    }
  },

  savePendingChanges(catId) {
    return (dispatch, getState) => {
      dispatch({type: this.ActionTypes.saveFeaturesStart});
      dispatch(actions.loadingDialog_show(true, 'Saving...', 'Saving features, this will take just a moment.'));
      const state = getState();
      const {featuresCreatorNew, asCustomer, auth, newScope} = state;
      const featuresChanges = getFeaturesChangesToPost(featuresCreatorNew.pendingFeatures);
      var tool = newScope.categoriesVisualizer;
      let masterFabId = getMasterFabricatorId(asCustomer.data ? asCustomer.data.masterFabricatorIds : auth.masterFabricatorIds, tool);

      getApiConfig('ProjectScope')
        .post(featuresChanges,`/feature-group-features/${masterFabId}`)
        .then(data => {
          dispatch(actions.loadingDialog_show(false))
          this.cancelPendingChanges(catId)(dispatch, getState);
          dispatch({
            type: this.ActionTypes.loadFeaturesEnd,
            payload: {...data, ...auth}
          })
        });
    }
  },

  resetFeatures() {
    return (dispatch) => {
      dispatch({type: ActionTypes.resetFeatures});
    }
  },

  ActionTypes
}
